import type { Accent } from '../data/volumes'

export interface AccentStyles {
  /** Solid block used for the volume code plate. */
  plate: string
  /** Hairline border matching the accent. */
  border: string
  /** Text colour for the volume name. */
  text: string
}

export const accentStyles: Record<Accent, AccentStyles> = {
  terracotta: {
    plate: 'bg-terracotta text-ivory',
    border: 'border-terracotta/40',
    text: 'text-terracotta-deep',
  },
  indigo: {
    plate: 'bg-indigo text-ivory',
    border: 'border-indigo/40',
    text: 'text-indigo-deep',
  },
  gold: {
    plate: 'bg-gold-ink text-ivory',
    border: 'border-gold/50',
    text: 'text-gold-ink',
  },
  teal: {
    plate: 'bg-teal text-ivory',
    border: 'border-teal/40',
    text: 'text-teal',
  },
  clay: {
    plate: 'bg-clay text-ivory',
    border: 'border-clay/45',
    text: 'text-terracotta-deep',
  },
  ink: {
    plate: 'bg-ink text-ivory',
    border: 'border-ink/30',
    text: 'text-ink',
  },
}
